export default class BenutzerDto {

  constructor(json) {
    if (json) {
      this.uuid = json.uuid;
      this.extId = json.extId
      this.nachname = json.nachname
      this.vorname = json.vorname
      this.email = json.email
      this.berechtigung = json.berechtigung
      this.createdOn = json.createdOn
      this.createdBy = json.createdBy
      this.archivedOn = json.archivedOn
      this.archivedBy = json.archivedBy
    }
  }

  get name() {
    return [this.vorname, this.nachname].filter(v => v).join(' ')
  }

  get role() {
    if (this.berechtigung) {
      return 'benutzer.berechtigung.' + this.berechtigung.toLowerCase()
    }
    return undefined
  }
}
